var quizQuestions = [
  {
    question: "In normal weather conditions, your turn signal light must be visible from how many feet away?",
    answers: {
      a: "100 feet",
      b: "200 feet",
      c: "300 feet",
      d: "400 feet"
    },
    description: "Your turn signals or \"blinkers\" must be visible from at least <strong>300 feet</strong> away during the daytime under normal weather conditions.",
    correctAnswer: "c"
  },
  {
    question: "In normal weather conditions, your horn must be audible from how many feet away?",
    answers: {
      a: "100 feet",
      b: "200 feet",
      c: "300 feet",
      d: "400 feet"
    },
    description: "Your car must be equipped with a horn that can be heard in normal conditions from at least <strong>200 feet</strong> away.",
    correctAnswer: "b"
  },
  {
    question: "If the road is clear, it is always okay to turn right at a red light.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "For safety reasons, <strong>some intersections are marked with signs forbidding drivers to turn right at a red light</strong>. In the absence of such a sign, you can turn right at a red light.",
    correctAnswer: "b"
  },
  {
    question: "To hand signal a left turn, you must stick your arm straight out.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>To signal left, you stick your arm straight out</strong>; to signal right, you stick your arm up, keeping your elbow straight; to signal a stop, you point your arm down.",
    correctAnswer: "a"
  },
  {
    question: "Where is it legal to pass?",
    answers: {
      a: "Within 100 feet of a bridge",
      b: "Within 100 feet of an intersection",
      c: "When the approaching a curve",
      d: "When driving to the right of a yellow dotted line"
    },
    description: "You can pass <strong>when driving to the right of a yellow dotted line</strong>. Passing within 100 feet of a bridge, intersection or railroad crossing is illegal, as is passing if you are approaching a curve.",
    correctAnswer: "d"
  },
  {
    question: "If you are attempting to pass a driver, you must return to your lane within how many feet of any oncoming vehicles?",
    answers: {
      a: "100 feet",
      b: "200 feet",
      c: "300 feet",
      d: "400 feet"
    },
    description: "If you are trying to pass another driver, make sure you can return to the right side of the road while still leaving at least <strong>200 feet</strong> between yourself and any approaching cars.",
    correctAnswer: "b"
  },
  {
    question: "Unless otherwise posted, the speed limit on a school's ground or when passing a school is:",
    answers: {
      a: "20 mph",
      b: "25 mph",
      c: "30 mph",
      d: "35 mph"
    },
    description: "Ohio has a set maximum speed limit for certain types of roads. Though local governments can change the speed limit in an area, the generally accepted speed limit for roads passing a school or school grounds in Ohio is <strong>20 mph</strong>.",
    correctAnswer: "a"
  },
  {
    question: "You cannot stop within 15 feet of a railroad crossing when crossing gates are lowering or lowered.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "You cannot stop within <strong>15 feet</strong> of a railroad crossing when the gates are lowering or lowered.",
    correctAnswer: "a"
  },
  {
    question: "Where is it illegal to park?",
    answers: {
      a: "Within 15 feet of a fire hydrant",
      b: "Within 20 feet of a crosswalk",
      c: "On a crosswalk",
      d: "Both B and C are correct"
    },
    description: "It is illegal to park within 10 feet of a fire hydrant but perfectly legal to park within 15 feet of one.",
    correctAnswer: "d"
  },
  {
    question: "How much can a driver be fined for failing to wear a seatbelt?",
    answers: {
      a: "$10",
      b: "$20",
      c: "$25",
      d: "$30"
    },
    description: "Drivers can be fined <strong>$30</strong> for failing to wear a seatbelt; passengers can be fined $20.",
    correctAnswer: "d"
  },
  {
    question: "If you are convicted of a OVI, how long can your license be suspected?",
    answers: {
      a: "3 months to a year",
      b: "3 months to 18 months",
      c: "6 months to 3 years",
      d: "6 months to 4 years"
    },
    description: "For a first offense, you can lose your license for <strong>6 months to 3 years</strong>; for a second offense, you can lose it for 1&ndash;5 years; and for a third offense you can lose it for up to 10 years.",
    correctAnswer: "c"
  },
  {
    question: "The legal BAC limit for drivers under 21 years old is:",
    answers: {
      a: ".00%",
      b: ".01%",
      c: ".02%",
      d: ".03%"
    },
    description: "While the legal limit is .08%, minors can be charged for having a BAC of just <strong>.02%</strong>.",
    correctAnswer: "b"
  },
  {
    question: "How many points will you get on your license for driving under the influence?",
    answers: {
      a: "4 points",
      b: "5 points",
      c: "6 points",
      d: "7 points"
    },
    description: "Should you operate a vehicle while under the influence of drugs, alcohol, or another substance that affects your ability to drive, you will receive <strong>six points</strong> on your driving record.",
    correctAnswer: "c"
  },
  {
    question: "You will receive two points for driving how much over the speed limit?",
    answers: {
      a: "6-10 mph",
      b: "11-29 mph",
      c: "30+ mph",
      d: "Both A and B are correct"
    },
    description: "You will receive no points for driving 1&ndash;5 mph and four points for driving 30+ mph. If you are driving between <strong>6-29 mph over</strong>, you receive 2 points.",
    correctAnswer: "d"
  },
  {
    question: "For receiving 12 or more points over a 2-year period, you will:",
    answers: {
      a: "Have your driving privileges suspended for 6 months",
      b: "Take a complete driver exam",
      c: "File proof of financial responsibility",
      d: "All of the above"
    },
    description: "If you receive 12 or more points over a 2-year period, you will <strong>have your driving privileges suspended for 6 months, take a complete driver exam and file proof of financial responsibility</strong>. You will also owe a reinstatement fee of $40.",
    correctAnswer: "d"
  },
  {
    question: "What does this sign mean?<br /><img src=\"/images/quiz/quiz6.jpg\" alt=\"Orange Triangle Sign\" />",
    answers: {
      a: "It alerts the driver about a nearing construction zone",
      b: "It is warning of an approaching hazard on the road",
      c: "It's for vehicles that drive less than 25 mph",
      d: "It's for cars with an impaired person behind-the-wheel"
    },
    description: "An orange triangle is for <strong>vehicles that drive less than 25 mph</strong>.",
    correctAnswer: "c"
  },
  {
    question: "When a road sign is green, it generally provides the driver with what information?",
    answers: {
      a: "A regulation",
      b: "Direction guidance",
      c: "A general warning",
      d: "Scenic guidance"
    },
    description: "Green signs usually indicate permitted movements and <strong>directional guidance</strong>. Brown signs, on the other hand, give motorists public recreation information and scenic guidance.",
    correctAnswer: "b"
  },
  {
    question: "A broken yellow line on the road means:",
    answers: {
      a: "You cannot pass, but you are free to use either lane",
      b: "You can pass, but you must drive on the right side of the line",
      c: "You can pass, and you are free to use both lanes",
      d: "You cannot pass, but you are free to use both lanes"
    },
    description: "A broken yellow line on the road means <strong>you can pass, but you must drive on the right side of the line</strong>. If the line is solid, you cannot pass. You also should not pass unless it is safe to do so.",
    correctAnswer: "b"
  },
  {
    question: "When should your headlights be on?",
    answers: {
      a: "Just after sunset",
      b: "When visibility is less than 600 feet",
      c: "Before sunrise",
      d: "All of the above"
    },
    description: "You must use your headlights <strong>between sunset and sunrise</strong>, not after the sun has set. You must also use them when <strong>visibility is less than 1,000 feet</strong>.",
    correctAnswer: "d"
  },
  {
    question: "How far away must you be from the car in front of you to stop safety in an emergency?",
    answers: {
      a: "One car length for every 5 miles of speed",
      b: "One car length for every 10 miles of speed",
      c: "One car length for every 15 miles of speed",
      d: "One car length for every 20 miles of speed"
    },
    description: "While you might think it is safe to drive closely behind the car in front of you, you should remember the three-second rule and maintain a safe distance in case of an emergency. ",
    correctAnswer: "b"
  }
];
